import { useEffect, useState } from "react";
import Header from "../../Pages/Shared/Header";
import Navbar from "../../Pages/Shared/NavBar";

const MainLayoutSubmitter = ({ children }) => {
  const [showNav, setShowNav] = useState(false);
  useEffect(() => {
    if (
      !window.location.pathname.includes("mainpage") &&
      window.location.pathname != "/SRFund/"
    ) {
      // If the current page's path does NOT include 'mainpage'
      // AND the path is NOT exactly "/grants_/",
      // then show the navigation menu by setting `setShowNav` to `true`.
      setShowNav(true);
    } else {
      // Otherwise, hide the navigation menu by setting `setShowNav` to `false`.
      setShowNav(false);
    }
  }, [window.location.pathname]);
  // console.log(window.location.pathname,"fhyfdhhfhdfh");

  return (
    <>
      <Header />
      {showNav ? <Navbar /> : <></>}

      <main>{children}</main>
    </>
  );
};

export default MainLayoutSubmitter;
